import { faPen, faRemove } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Disponibility from 'components/disponibility/Disponibility';
import Spinner from 'components/spinner/Spinner';
import Placeholder from 'assets/images/car-part-placeholder.png';

import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import './NonTecdocPart.scss';

import CheckboxCellTab from 'components/CheckboxCellTab/CheckboxCellTab';
import { INonTecDocPart } from 'interfaces/nonTecdocCatalog';
import { getMarketplaceBaseUrl } from 'utils/marketplace';
import CURRENCY from 'utils/constants/currency';

type Props = {
  data: INonTecDocPart[],
  loading: boolean,
  register?;
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  openNonTecdocModal: (id: number) => void
  deleteItem: (id: number) => void
};


const NonTecdocPart: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem('userData')!);

  function getAvailablityTitle(item) {


    if (item.available && typeof item.available === 'object') {
      const newLimit: { uv?: string, warehouse_main } = { ...item.available };

      delete newLimit.uv;

      return Object.values(newLimit).reduce((acc, item) => Number(acc) + Number(item?.quantity), 0);
    }

    return item.available;
  }

  function getPrice(item) {

    if (item.price && typeof item.price === 'object') {
      if (item.price?.price) {
        return item.price.price;
      } else {
        return null;
      }
    }

    return item.price;
  }

  return (
    <div className="item-container-shop-non_tecdoc">
      {
        props.loading ? <Spinner /> :
          props.data.length ?
            props.data.map((item, index) => {
              return (
                <div className="item-shop" key={index}>
                  <div className="header">
                    <div className="checkboxCellTab">
                      <CheckboxCellTab handleOnChange={props.handleOnChange} id={item.id} register={props.register}></CheckboxCellTab>
                    </div>
                    <div className="img">
                      <img src={item.image ? `${getMarketplaceBaseUrl()}${item.image}` :  Placeholder}/>
                    </div>
                    <div className="content">
                      <div className="title">{item.supplier_name}</div>
                      <div className="reference">{item.reference}</div>
                    </div>
                  </div>
                  <div className="body">
                  </div>
                  <div className="footer">
                    <div className="quantity">

                      <Disponibility value={0} limit={getAvailablityTitle(item)} />
                      <div className="disponibility-porduct">
                        {' '}
                        {t('_up_to')} :{' '}
                        <span className="disponibility-count">
                          {getAvailablityTitle(item)} {t('_products')}
                        </span>
                      </div>

                    </div>
                    <div className="cart">
                      <div className="cart-price">{getPrice(item) ? `${CURRENCY[user!.currency]}${getPrice(item)}` : '-'} </div>
                      <div className="cart-button">
                        <button className="button-edit" onClick={() => props.openNonTecdocModal(item.id)}>
                          <FontAwesomeIcon icon={faPen} className="icon-edit" />
                        </button>
                        <button className="button-delete" onClick={() => props.deleteItem(item.id)}>
                          <FontAwesomeIcon icon={faRemove} className="icon-delete" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }) :
            <div className="no-data">
              {t('_no_data')}
            </div>

      }
    </div>
  );
};

NonTecdocPart.displayName = 'NonTecdocPart';

export default NonTecdocPart;
